import { solfegeNoteCount } from '../../../../../common/src/sing_in_solfege.ts';
import { SquareColor, SummaryCardRow } from '../learn_summary_screen.tsx';
import {
  solfegeBestStreak,
  SolfegeSessionState,
  solfegeSummaryScore,
  solfegeSummarySquares,
} from './solfege_session.ts';

// What a Sing in Solfège session adds to the shared Learn summary (issue #3722), in the manner of
// Interval Training's (interval_summary.ts): the score, the best run and the squares read from the
// session's selectors, over the last take of each phrase. Two things differ from the other modules,
// and the summary says both rather than leaving them to be guessed: a square is a whole phrase, not
// one attempt at one note, and the best run ("Best run: 9 in a row", as LearnSummaryScreen words
// every module's) counts notes on pitch in a row across the phrases. The line under the squares
// says what a square's colour means and what the run counts, and a "Notes on pitch" row on the card
// gives the session's notes, so the run and the squares have a number to be read against. The page
// spreads the result into <LearnSummaryScreen> with the props every exercise passes.

export const solfegeSquaresCaption =
  'Each square is a phrase. Green: nearly every note on pitch. Yellow: half or more. Red: fewer than half. ' +
  'Your best run counts notes on pitch in a row.';
export const notesOnPitchLabel = 'Notes on pitch';

export interface SolfegeSummaryProps {
  score: number;
  bestStreak: number;
  squares: SquareColor[];
  squaresCaption: string;
  extraRows: SummaryCardRow[];
}

// "31 of 38": the session's green notes over its graded ones
export function sessionNotesOnPitchText(state: SolfegeSessionState): string {
  const { onPitch, graded } = solfegeNoteCount(state.finished.flat());
  return `${onPitch} of ${graded}`;
}

export function solfegeSummaryProps(state: SolfegeSessionState): SolfegeSummaryProps {
  return {
    score: solfegeSummaryScore(state),
    bestStreak: solfegeBestStreak(state),
    squares: solfegeSummarySquares(state),
    squaresCaption: solfegeSquaresCaption,
    extraRows: state.finished.length === 0 ? [] : [{ label: notesOnPitchLabel, value: sessionNotesOnPitchText(state) }],
  };
}
